export default "__VITE_ASSET__DjEBJnkB__"